import { Editor, Extension } from '@tiptap/core';
import { enhanceWithNotesCommand } from './enhance-with-note';
import { makeLongerCommand } from './make-longer';
import { makeShorterCommand } from './make-shorter';
import { AskAiCommand as AskAiCommandEnum, AskAiCommandOptions } from './types';
import { retainMetaForNode } from '../utils/replace-content';
import { InProgressStorageManager } from './utils/inprogress-storage-manager';
import { setTransactionMetaByAskAiActionCommand } from './utils/transaction';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    askAiCommand: {
      makeLonger: () => ReturnType;
      makeShorter: () => ReturnType;
      enhanceWithMyNotes: () => ReturnType;
      setEditableByAskAiCommand: (isEditable: boolean) => ReturnType;
    };
  }
}
export type AskAiCommandStorage = {
  inProgressCommandSet: WeakMap<Editor, AskAiCommandEnum[]>;
};

export const AskAiCommandName = 'askAiCommand';
const BaseAskAiCommand = Extension.create<
  AskAiCommandOptions,
  AskAiCommandStorage
>({
  name: AskAiCommandName,
  addOptions() {
    return {
      processAskAiRequest: () => {},
      contentReplacementOptions: {
        retainMetaForNode,
      },
    };
  },
  addStorage() {
    return {
      inProgressCommandSet: new WeakMap(),
    };
  },
  addCommands() {
    return {
      setEditableByAskAiCommand:
        (isEditable: boolean) =>
        ({ editor }) => {
          editor.view.dispatch(editor.state.tr.setMeta('byAskAiCommand', true));

          editor.setEditable(isEditable);

          return true;
        },
      makeLonger: () => (props) => {
        setTransactionMetaByAskAiActionCommand(props);
        makeLongerCommand({ ...props, options: this.options });

        return true;
      },
      makeShorter: () => (props) => {
        setTransactionMetaByAskAiActionCommand(props);
        makeShorterCommand({ ...props, options: this.options });

        return true;
      },
      enhanceWithMyNotes: () => (props) => {
        setTransactionMetaByAskAiActionCommand(props);
        enhanceWithNotesCommand({ ...props, options: this.options });

        return true;
      },
    };
  },
  onTransaction({ editor, transaction }) {
    if (!transaction.getMeta('byAskAiCommand')) {
      if (
        editor.isEditable &&
        InProgressStorageManager(editor).getInProgressCommands().length > 0
      ) {
        editor.commands.setEditableByAskAiCommand(false);
      }
    }
  },
});

export const AskAiCommand = {
  configure: (options: AskAiCommandOptions) => {
    if (!options.processAskAiRequest) {
      throw new Error('AskAiCommand requires onEnhanceSelection option');
    }

    return BaseAskAiCommand.configure(options);
  },
};
